/* ─────────────────────────────────────────────────────────────
   Upsell Marelle — tiroir de panier

   L'écouteur est délégué au document, jamais posé sur un nœud du
   tiroir : après chaque mutation, section-cart-drawer.js remplace
   l'intégralité de .section-cart-drawer__body par innerHTML
   (l. 709). Tout écouteur interne serait perdu au premier ajout.

   L'ajout réutilise window.theme.cart_api.add() — même appel que
   _handleGiftWrapToggle (component-cart-blocks.js l. 588) — en
   demandant le rendu de la section, puis passe le HTML reçu à
   drawer._refreshCart(). Aucun fetch réimplémenté, aucun double
   rendu : _refreshCart pose _lastRefreshAt, ce qui neutralise le
   _refreshFromExternalUpdate déclenché ensuite par cart:updated.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.__marelleUpsellBound) return;
  window.__marelleUpsellBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('[data-m-upsell-add]');
    if (!btn || btn.disabled) return;

    var root = btn.closest('[data-m-upsell]');
    if (!root) return;

    var field = root.querySelector('[data-m-upsell-select]');
    var variantId = field ? parseInt(field.value, 10) : 0;
    if (!variantId) return;

    var drawer = btn.closest('cart-drawer') || document.querySelector('cart-drawer');
    var api = window.theme && window.theme.cart_api;
    if (!drawer || !api || typeof api.add !== 'function') return;

    var sectionId = drawer.dataset.sectionId;

    btn.disabled = true;
    root.classList.add('is-pending');

    api
      .add([{ id: variantId, quantity: 1 }], [sectionId], { suppressAutoOpen: true })
      .then(function (data) {
        /* Le corps du tiroir est remplacé : ce bloc disparaît de
           lui-même, la garde Liquid le voyant désormais au panier.
           Inutile de réactiver le bouton, il n'existe plus. */
        if (data && data.sections && data.sections[sectionId] && drawer._refreshCart) {
          drawer._refreshCart(data.sections[sectionId]);
        } else {
          btn.disabled = false;
          root.classList.remove('is-pending');
        }
      })
      .catch(function () {
        btn.disabled = false;
        root.classList.remove('is-pending');
      });
  });
})();
